import styled from 'styled-components'

export const BadgeContainer = styled.div`
  align-items: center;
  border-radius: 0.125rem;
  display: flex;
  justify-content: center;
  width: 2.5rem;

  ${ ({ summaryView, isRostered }) => {
    if (summaryView) {
      return isRostered ?
        `background-color: #006F1A; color: white;` : `background-color: #F8F9FA; color: #1f1f1f;`
    }
    
    return `
      background-color: #006F1A;
      color: white;
      margin-left: 1.25rem;
    `
  }}
`